import React, { useRef, useState, useEffect } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import useAuthStore from '../stores/authStore';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './GoogleSignInButton.css';

const GoogleSignInButton = ({ onError }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const nextPath = searchParams.get('next') || '';
  const { setAuth } = useAuthStore();
  const containerRef = useRef(null);
  const [buttonWidth, setButtonWidth] = useState(312);

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const width = Math.floor(entry.contentRect.width);
        if (width > 0) setButtonWidth(width);
      }
    });

    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/google-signin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: credentialResponse.credential })
      });

      const data = await response.json();

      if (!response.ok) {
        onError?.(data.error || 'Google signin failed');
        return;
      }

      // Save website/member auth only (admin panel uses /admin-signin)
      setAuth(data.user, data.accessToken);

      const isEmployer = data.user?.accountType === 'employer';
      const hasCandidateProfileName = Boolean(data.user?.fullName?.trim());
      if (!isEmployer && !hasCandidateProfileName) {
        navigate('/onboarding');
      } else if (nextPath && nextPath.startsWith('/') && !nextPath.startsWith('/admin')) {
        navigate(nextPath);
      } else {
        navigate('/');
      }
    } catch (error) {
      console.error('Google signin error:', error);
      onError?.('Network error. Please try again.');
    }
  };

  const handleGoogleError = () => {
    onError?.('Google signin failed. Please try again.');
  };

  return (
    <div className="google-signin-wrapper">
      <div className="google-signin-button-container" ref={containerRef}>
        <GoogleLogin
          onSuccess={handleGoogleSuccess}
          onError={handleGoogleError}
          text="continue_with"
          size="medium"
          width={buttonWidth}
        />
      </div>
    </div>
  );
};

export default GoogleSignInButton;
